export default __webpack_public_path__ + "82576ac7cd61de61f85a33bf7e7a01be.svg";